<template>
    <div class="bg-gradient-to-r from-blue-50 to-orange-50 py-12">
        <div class="max-w-7xl mx-auto px-4">
            <div class="grid grid-cols-4 gap-8">
                <div class="text-center">
                    <div class="text-4xl font-bold text-blue-600 mb-2">10+</div>
                    <div class="text-gray-600">年专业服务经验</div>
                </div>
                <div class="text-center">
                    <div class="text-4xl font-bold text-blue-600 mb-2">20,000+</div>
                    <div class="text-gray-600">服务学员</div>
                </div>
                <div class="text-center">
                    <div class="text-4xl font-bold text-blue-600 mb-2">100+</div>
                    <div class="text-gray-600">企业客户</div>
                </div>
                <div class="text-center">
                    <div class="text-4xl font-bold text-blue-600 mb-2">98%</div>
                    <div class="text-gray-600">客户满意度</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteStatistics'
}
</script>